import { useEffect, useState } from "react";
import {
  faChevronLeft,
  faSignOutAlt,
  faHandshake,
  faTimes,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./BurgerMenu.module.css";
import { Link, useHistory } from "react-router-dom";
import { getUserInfo } from "../../Api/BarestServices";
import { errorToast } from "../../Toast/Toast";
import { Avatar, Progress } from "antd";
import { UserOutlined } from "@ant-design/icons";
import {
  ChatDots,
  ClockHistory,
  Headset,
  Heart,
  PersonLinesFill,
  Send,
  Shift,
  QuestionCircleFill,
  PersonCheckFill,
  CreditCard,
  PinFill,
  Hammer,
  Coin,
  Wallet,
  CardList,
} from "react-bootstrap-icons";
import { separate } from "../../Seprate/Seprate";
const BurgerMenu = (props) => {
  const data = [
    {
      id: "9",
      title: "فاکتور ها",
      icon: <CardList className={Style.acountIcon} />,
      link: "/facturelist",
    },
    {
      id: "1",
      title: "نظرات من",
      icon: <ChatDots className={Style.acountIcon} />,
      link: "/myComments",
    },
    {
      id: "2",
      title: "پشتیبانی",
      icon: <Headset className={Style.acountIcon} />,
      link: "/support",
    },
    {
      id: "3",
      title: "مورد علاقه های من",
      icon: <Heart className={Style.acountIcon} />,
      link: "/favorite",
    },
    {
      id: "4",
      title: "همکاری با ما",
      icon: <FontAwesomeIcon icon={faHandshake} className={Style.acountIcon} />,
      link: "/cooperationRequest",
    },
    {
      id: "4",
      title: "درباره ی بَرِست",
      icon: <FontAwesomeIcon icon={faList} className={Style.acountIcon} />,
      link: "/aboutus",
    },
    {
      id: "5",
      title: "بازدید های اخیر",
      icon: <ClockHistory className={Style.acountIcon} />,
      link: "/lastseen",
    },
    {
      id: "6",
      title: "راهنما",
      icon: <QuestionCircleFill className={Style.acountIcon} />,
      link: "/guidepage",
    },
    {
      id: "7",
      title: "کد تخفیف",
      icon: <ClockHistory className={Style.acountIcon} />,
      link: "/choose",
    },
    {
      id: "8",
      title: "شرایط و قوانین",
      icon: <Hammer className={Style.acountIcon} />,
      link: "/terms",
    },
  ];
  const [UserFirstName, setUserUserFirstName] = useState("اول ثبت نام کنید");
  const [UserLastName, setUserUserLastName] = useState("");
  const [info, setInfo] = useState("");
  const [show, setShow] = useState(true);
  const [openAccardion, setOpenAccardion] = useState(false);
  useEffect(() => {
    UserInformationHandler();
  }, [UserFirstName, UserLastName]);
  const UserInformationHandler = async () => {
    getUserInfo((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
        } else {
          if (res.status === 0) {
            setUserUserFirstName("ابتدا وارد");
            setUserUserLastName("شوید");
          } else if (res.status === -2) {
            setShow(false);
          } else {
            setUserUserFirstName(res.info.first_name);
            localStorage.setItem("FirstName", res.info.first_name);
            setUserUserLastName(res.info.last_name);
            localStorage.setItem("LName", res.info.last_name);
            localStorage.setItem("phone", res.info.phone);
            setInfo(res.info);
          }
        }
      } else {
        console.error(res)
      }
    });
  };

  const goToEditInfo = () => {
    history.push("/userinformation");
  };
  // const isLogin = () => !!localStorage.getItem("JwtTokens")&& !!localStorage.getItem('address_compact')
  const isLogin = () => !!localStorage.getItem("JwtTokens");
  let history = useHistory();
  const LogoutHandler = () => {
    if (isLogin()) {
      localStorage.clear();
      errorToast("خارج شدین");
      setTimeout(() => {
        history.push("/login");
      }, 1000);
    } else {
      errorToast("شما هنوز وارد نشدید!!");
    }
  };
  let name = null;
  if (UserFirstName === undefined) {
    name = "ابتدا وارد";
  } else {
    name = UserFirstName;
  }
  let last = null;
  if (UserLastName === undefined) {
    last = "شوید";
  } else {
    last = UserLastName;
  }
  return (
    <nav className={props.show ? Style.PageHolder : Style.PageHolderFalse}>
      <section className={Style.MenuHeader}>
        <div onClick={props.CloseMenuHandler}>
          <FontAwesomeIcon className={Style.closeIcon} icon={faTimes} />
        </div>
      </section>
      <div className={Style.userInfoHolder}>
        <Progress
          strokeColor={"#c20c64"}
          trailColor={"#d1d1d1"}
          type="circle"
          percent={
            info.score % 100 === 0 && info.score > 100 ? 100 : info.score % 100
          }
          format={() => (
            <Avatar
              style={{
                backgroundColor: "#ffff",
                color: "#c20c64",
                lineHeight: "122px",
              }}
              size={106}
              icon={<UserOutlined />}
            />
          )}
        />
        <div className={Style.infoHolder}>
          <div className={Style.editandinfo}>
            <h3 className={Style.nameHolder}>{`${name} ${last}`}</h3>
            <h3 className={Style.phoneHolder}>
              {localStorage.getItem("phone")}
            </h3>
            <button className={Style.editBtn} onClick={goToEditInfo}>
              ویرایش حساب کاربری{" "}
            </button>
          </div>
          {show ? (
            <div className={Style.scoreWallet}>
              <h3>
                امتیاز : <span className={Style.scoreHolder}>{info.score}</span>
              </h3>
              <h3>
                {" "}
                 کیف پول:{" "}
                <span className={Style.scoreHolder}>{separate(info.wallet)} تومان</span>
              </h3>
              {parseFloat(info.debt)>0&&<h3>
                {" "}
                  کمک برست:{" "}
                <span className={Style.scoreHolder}>{separate(info.debt)} تومان</span>
              </h3>}
            </div>
          ) : null}
        </div>
      </div>
      <section className={Style.Navigation}>
        <div
          onClick={() => setOpenAccardion(!openAccardion)}
          className={Style.accardionHolder}
        >
          <div className={Style.firstItem}>
            <FontAwesomeIcon className={Style.arrowIcon} icon={faChevronLeft} />
            <div className={Style.right}>
              <p className={Style.accardionText}>حساب کاربری</p>
              <PersonLinesFill className={Style.acountIcon} />
            </div>
          </div>
        </div>
        {openAccardion ? (
          <div className={Style.AccardionHolder}>
            <div className={Style.eachAccardion}>
              <Link to={"/introductionCode"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <Send className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>لینک دعوت</p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            <div className={Style.eachAccardion}>
              <Link to={"/iban"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <CreditCard className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>شماره شبا</p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            {/* <div className={Style.eachAccardion}>
              <Link to={{pathname:"/choose",state:info}} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <Percent className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>کد تخفیف </p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div> */}
            <div className={Style.eachAccardion}>
              <Link to={"/microtransaction"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <Shift className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>ریز تراکنش </p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            <div className={Style.eachAccardion}>
              <Link to={"/subset"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <PersonCheckFill className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>زیرمجموعه </p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            <div className={Style.eachAccardion}>
              <Link to={"/changeaddress"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <PinFill className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>ویرایش آدرس </p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            <div className={Style.eachAccardion}>
              <Link to={"/ppltransaction"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <Coin className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>انتقال مبلغ کیف پول</p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            <div className={Style.eachAccardion}>
              <Link to={"/chargewallet"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <Wallet className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>شارژ کیف پول</p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
            <div className={Style.eachAccardion}>
              <Link to={"/baresthelp"} className={Style.linkAccardion}>
                <div className={Style.titleAccardionHolder}>
                  <Coin className={Style.accardionIcon} />
                  <p className={Style.titleAccardion}>کمک برست</p>
                </div>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={Style.arrowIconAccardion}
                />
              </Link>
            </div>
          </div>
        ) : null}
        {data.map((item, index) => {
          return (
            <div key={index} className={Style.menuItem}>
      <Link to={item.link} className={Style.linkItem}>
        <FontAwesomeIcon
          icon={faChevronLeft}
          className={Style.arrowIcon}
        />
        <div className={Style.leftArrowHolder}>
          <p className={Style.title}>
            {item.id === "9" && info && Number(info.facture) > 0 && (
              <span
                style={{
                  backgroundColor: "#ff4d4f",
                  color: "#fff",
                  borderRadius: "50%",
                  padding: "0px 6px",
                  fontSize: "12px",
                  marginRight: "8px",
                  display: "inline-block",
                  lineHeight: "20px",
                  textAlign: "center"
                }}
              >
                {info.facture}
              </span>
            )}
            {item.title}
          </p>
          {item.icon}
        </div>
      </Link>
    </div>
          );
        })}
        {localStorage.getItem("JwtTokens") ? (
          <section className={Style.SignOutSection} onClick={LogoutHandler}>
            <div className={Style.exitIcon}>
              {" "}
              <FontAwesomeIcon icon={faSignOutAlt} />
            </div>
            <p className={Style.exit}>خروج</p>
          </section>
        ) : null}
      </section>
    </nav>
  );
};
export default BurgerMenu;
